<template>
    <div>
        <div class="row_center_end quantity_container" v-if="quantity !== 0">
            <div class="row_center_center quantity">{{ quantity }}</div>
        </div>
        <div class="row_center_between w-[94%]">
            <div class="row_center_center" style="background-color: #DDDDDD; border-radius: 50%; padding: 2px;"
                @click="subtractQuantity">
                <text id="remove" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">remove</text>
            </div>

            <div class="row_center_start" @click="addQuantity">
                <text>{{ subOption.name }}</text>
                <text v-if="subOption['replacementPrice'] !== undefined && subOption.replacementPrice !== 0">{{ formatPriceChange(subOption.replacementPrice) }}</text>
                <text v-else-if="subOption['replacementPrice'] === undefined && subOption.price != 0">{{ formatPriceChange(subOption.price) }}</text>

            </div>

            <div class="row_center_center" style="background-color: #FBCB02; border-radius: 50%; padding: 2px;"
                @click="addQuantity">
                <text id="add" class="button-icon"
                    style="color: #000; font-size: 32px; height: 32px; width: 32px">add</text>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        subOption: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        quantity: {
            type: Number,
            default: 0,
            required: true,
        }
    },
    methods: {
        formatPriceChange(price) {
            return price > 0 ? `+${price}` : price
        },
        subtractQuantity() {
            this.$emit("subtractQuantity");
        },
        addQuantity() {
            this.$emit("addQuantity");
        }
    }
}
</script>
<style lang="scss" scoped>
.quantity_container {
    width: 100%;
    height: 0px;
    position: relative;
}

.quantity {
    position: absolute;
    top: -22px;
    right: -25px;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    background-color: #D60A0A;
    flex-shrink: 0;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    font-family: PingFang SC;
}
</style>
